module.exports = __webpack_public_path__ + "img/home-nav2.ef3b66ac.png";